module.exports = __webpack_public_path__ + "static/media/ic_selection_selected.5c53b1ba.svg";